import { Component, Input, Output, EventEmitter, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-notification-panel',
  templateUrl: './notification-panel.component.html',
  styleUrls: ['./notification-panel.component.css']
})
export class NotificationPanelComponent {
  @Input() showNotification: boolean = false;
  @Input() notifications: any[] = [];
  @Input() notificationCount: number = 0;
  @Input() showClearAll: boolean = false;
  
  @Output() notificationClick = new EventEmitter<{notification: any, event: MouseEvent}>();
  @Output() clearAllClick = new EventEmitter<any[]>();
  @Output() panelClick = new EventEmitter<Event>();

  constructor(private sanitizer: DomSanitizer) {}

 getSanitizedHtml(html: string): SafeHtml {
  return this.sanitizer.bypassSecurityTrustHtml(html);
}

  stripHtml(text: string): string {
    return text.replace(/<[^>]*>/g, '');
  }

//   onNotificationClick(notification: any, event: MouseEvent): void {
//     const target = event.target as HTMLElement;
//     // Don't toggle when clicking interactive elements (checkbox, link, button, label, etc.)
//     if (target.closest('input, a, button, label, select, textarea')) {
//       return;
//     }
//     notification.checked = !notification.checked;
//     this.notificationClick.emit({notification, event});
//   }
  onNotificationClick(notification: any, event: Event) {
  // Prevent clicking on the checkbox from double-toggling
  if ((event.target as HTMLElement).classList.contains('notification-checkbox')) {
    return;
  }

  // Toggle checkbox
  notification.checked = !notification.checked;
}

hasCheckedNotifications(): boolean {
  return this.notifications.some(notification => notification.checked);
}
  onClearAll(): void {
    const checkedNotifications = this.notifications.filter(notification => notification.checked);
    
    // Uncheck all notifications locally
    this.notifications.forEach(notification => notification.checked = false);
    
    // Emit the list of checked notifications
    this.clearAllClick.emit(checkedNotifications);
  }

  onPanelClick(event: Event): void {
    event.stopPropagation();
    this.panelClick.emit(event);
  }
  
}